import type { Peer } from "@circle-react/types/Live/Peer";

export const AudioPlayer = ({ participant }: { participant: Peer }) => {
  const { microphonePublication, isLocal } = {
    microphonePublication: {
      track: undefined,
      isSubscribed: false,
      isMuted: false,
      isEnabled: false,
    },
    isLocal: false,
  };
  if (
    !microphonePublication?.track ||
    !microphonePublication?.isSubscribed ||
    microphonePublication?.isMuted ||
    !microphonePublication?.isEnabled
  ) {
    return null;
  }

  if (isLocal) {
    return <div>{participant?.name}</div>;
  }

  return <>{participant?.name}</>;
};
